import { backdropClasses, Components, Theme } from '@mui/material';

export const MuiDrawer: Components<Theme>['MuiDrawer'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`& .${backdropClasses.root}`]: { backgroundColor: theme.palette.background.backdrop },
    }),
    paper: ({ theme }) => {
      if (theme.featureFlags.panwRebrandStubYear) {
        return {
          backgroundColor: theme.palette.background.popover,
          // Drawers render in a portal under `body`, outside Cloud's `#root` where colorScheme is set.
          // Without this, scrollbars stay on the light scheme.
          colorScheme: theme.palette.mode,
        };
      }

      const backgroundStyle =
        theme.palette.mode === 'light'
          ? {}
          : {
              backgroundImage: 'unset',
              backgroundColor: theme.palette.designSystem.grey[900],
              // Drawers render in a portal under `body`, outside Cloud's `#root` where colorScheme is set.
              // Without this, scrollbars stay on the light scheme.
              colorScheme: theme.palette.mode,
            };

      return {
        ...backgroundStyle,
      };
    },
  },
};
